import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/mes-conges/")({
  loader: () => {
    throw redirect({ to: "/conges/me" });
  },
});
